export class Entity {
	entityid: number;
	entityname: string;
	entityaddress: string;
	cityid: number;
	stateid: number;
	pincode: number;
	gstin: string;
	//managername: string;
	managerid: number;
	active: number;	
    createon: Date;
	createdby:number;	
    modifiedon: Date;	
    modifiedby: number;
	cityname: string;
	statename: string;
	managername: string;
	
}